module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/feedback/feedback.component.css
// module id = ./src/app/feedback/feedback.component.css
// module chunks = main